import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lm-custom-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomIconComponent implements OnInit {
  @Input() src = 'no-icon';

  ngOnInit(): void {
    console.log(this.src);
  }
}
